/**
 * Motivo que a EMPRESA registra ao pedir nova cobrança.
 *
 * Constante, e não campo de texto: o Jubileu não pede justificativa ao cliente —
 * o fato relevante para a auditoria é QUEM pediu e que foi pelo atraso. O
 * servidor exige um motivo de 10+ caracteres porque a mesma operação, do lado da
 * Secretaria, é discricionária.
 *
 * Mora aqui porque as duas superfícies que pedem regeração — a linha da aba
 * Financeiro e o card de custas do Resumo — precisam gravar a MESMA string na
 * trilha de auditoria. Duplicada, uma edição num dos lados produziria dois
 * motivos diferentes para a mesma operação.
 */
export const MOTIVO_REGERACAO_CLIENTE =
  'Cobrança em atraso — nova cobrança solicitada pela empresa';
